export function getApiErrorMessage(error, fallback = 'Ocorreu um erro. Tente novamente.') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg || JSON.stringify(item)).join(', ');
  }
  return error?.message || fallback;
}
